import type { HttpClient } from 'services/api-client/client';
import type { CloudResourceApi } from '@env0/cloud-resource-service/api';
import { returnData } from 'services/api-client/client';

export default (client: HttpClient) => ({
  findCloudResources: async (
    body: CloudResourceApi.FindCloudResources.Request.Body
  ): Promise<CloudResourceApi.FindCloudResources.Response> =>
    client.post<CloudResourceApi.FindCloudResources.Response>('/cloud/resources', body).then(returnData),
  updateCloudResources: async (
    body: CloudResourceApi.UpdateCloudResources.Request.Body
  ): Promise<CloudResourceApi.UpdateCloudResources.Response> =>
    client.put<CloudResourceApi.UpdateCloudResources.Response>('/cloud/resources', body).then(returnData),
  startIacGeneration: async (body: CloudResourceApi.StartIacGeneration.Request.Body) =>
    client.post<CloudResourceApi.StartIacGeneration.Response>('/cloud/resources/generate-iac', body).then(returnData),
  getIacGenerationResult: async (jobId: string) =>
    client
      .get<CloudResourceApi.GetIacGenerationResult.Response>(`/cloud/resources/generate-iac/${jobId}`)
      .then(returnData),
  getChangeEventUrl: async (eventId: string) =>
    client.get<CloudResourceApi.GetChangeEventUrl.Response>(`cloud/resources/events/${eventId}`).then(returnData),
  getResourceChangeEvents: async (cloudResourceId: string) =>
    client
      .get<CloudResourceApi.GetResourceEvents.Response>(`cloud/resources/${cloudResourceId}/events`)
      .then(returnData),
  getResourceFullEvent: async (eventId: string) =>
    client.get<CloudResourceApi.GetEventById.Response>(`cloud/events/${eventId}`).then(returnData)
});
